const skills = [
    {
        skill: 'HTML5',
        progress: '75%'
    },
    {
        skill: 'CSS3',
        progress: '65%'
    },
    {
        skill: 'BOOTSTRAP',
        progress: '60%'
    },
    {
        skill: 'JAVASCRIPT',
        progress: '70%'
    },
    {
        skill: 'REACT.JS',
        progress: '75%'
    },
    {
        skill: 'NODE.JS',
        progress: '65%'
    },
    {
        skill: 'EXPRESS.JS',
        progress: '65%'
    },
    {
        skill: 'POSTGRESQL',
        progress: '50%'
    },
    {
        skill: 'JAVA',
        progress: '70%'
    },
]

export default skills;